import { kmsClient } from 'api/apollo';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { CREATIVE_VIDEOS } from './creativeVideos.query';
import { EXTRACT_VIDEO_FROM_ID } from './extractVideoFromId.query';
import { UPLOAD_VIDEO_FROM_URL } from './uploadVideoFromUrl.mutation';
import { UPLOAD_VIDEO_FROM_FILE } from './uploadVideoFromFile.mutation';
import { CreativeVideos, CreativeVideosVariables } from './__generated__/CreativeVideos';
import { UploadVideoFromUrl, UploadVideoFromUrlVariables } from './__generated__/UploadVideoFromUrl';
import { ExtractVideoFromId, ExtractVideoFromIdVariables } from './__generated__/ExtractVideoFromId';
import { UploadVideoFromFile, UploadVideoFromFileVariables } from './__generated__/UploadVideoFromFile';

export const useCreativeVideos = (variables: CreativeVideosVariables) => {
  return useLazyQuery<CreativeVideos, CreativeVideosVariables>(CREATIVE_VIDEOS, {
    client: kmsClient,
    variables,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const useExtractVideoFromId = () => {
  return useLazyQuery<ExtractVideoFromId, ExtractVideoFromIdVariables>(EXTRACT_VIDEO_FROM_ID, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};

export const useUploadVideoFromUrl = () => {
  return useMutation<UploadVideoFromUrl, UploadVideoFromUrlVariables>(UPLOAD_VIDEO_FROM_URL, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true
  });
};

export const useUploadVideoFromFile = () => {
  return useMutation<UploadVideoFromFile, UploadVideoFromFileVariables>(UPLOAD_VIDEO_FROM_FILE, {
    client: kmsClient,
    notifyOnNetworkStatusChange: true
  });
};
